/**
 * Get the return path based on the 'from' query parameter.
 * Used to navigate back to the correct tab after viewing/editing a broadcast.
 *
 * @param {Object} location - React Router location object
 * @returns {string} The path to navigate to
 */
export const getReturnPath = location => {
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from');

  if (from === 'broadcasts') return '/broadcasts';
  if (from === 'highlights') return '/highlights';

  if (from === 'calendar') {
    const cy = searchParams.get('cy');
    const cm = searchParams.get('cm');
    const hf = searchParams.get('hf');
    const bf = searchParams.get('bf');

    let path;
    if (cy && cm !== null && cm !== undefined && cm !== '') {
      path = `/calendar/${cy}/${cm}`;
    } else if (cy) {
      path = `/calendar/${cy}`;
    } else {
      path = '/calendar';
    }

    const returnParams = new URLSearchParams();
    if (hf) returnParams.set('hf', hf);
    if (bf) returnParams.set('bf', bf);
    const qs = returnParams.toString();
    return qs ? `${path}?${qs}` : path;
  }

  return '/';
};

/**
 * Navigate back from the broadcast form to the correct origin page.
 * Uses window.location.href for cross-page navigation (e.g. broadcasts → calendar)
 * since they are separate HashRouters.
 *
 * @param {Object} history - React Router history object
 * @param {Object} location - React Router location object
 */
export const navigateBack = (history, location) => {
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get('from');

  if (from === 'calendar') {
    const cy = searchParams.get('cy');
    const cm = searchParams.get('cm');
    const hf = searchParams.get('hf');
    const bf = searchParams.get('bf');

    let path = '/client_admin/plan#calendar';
    if (cy && cm !== null && cm !== undefined && cm !== '') {
      path = `/client_admin/plan#calendar/${cy}/${cm}`;
    } else if (cy) {
      path = `/client_admin/plan#calendar/${cy}`;
    }

    const returnParams = new URLSearchParams();
    if (hf) returnParams.set('hf', hf);
    if (bf) returnParams.set('bf', bf);
    const qs = returnParams.toString();
    window.location.href = qs ? `${path}?${qs}` : path;
    return;
  }

  // Default: return to broadcast list (root of current HashRouter)
  history.push('/');
};
